export default __webpack_public_path__ + "static/media/button22.51edaf42.wav";